import { CSSProperties } from 'react';
import { Box } from '@cbhq/cds-web/layout';

import { useClientProps } from '../ProfileMenu/providers/ClientPropsProvider';
import { useProfileMenuV2 } from '../ProfileMenu/providers/ProfileMenuV2Provider';

import { HelpMenuContent } from './HelpMenuContent';

const helpMenuContainerStyle: CSSProperties = {
  order: -1,
};

export function HelpMenu() {
  const { showHelpMenu } = useClientProps();
  const { helpMenu } = useProfileMenuV2();

  if (!helpMenu || !showHelpMenu) {
    return null;
  }

  return (
    <Box style={helpMenuContainerStyle}>
      <HelpMenuContent />
    </Box>
  );
}
